export function AppendReturnUrl(url: string, returnUrl: string) {
  return `${url}?returnUrl=${encodeURIComponent(returnUrl)}`;
}